import { CrmAuthorId, evergreenContactAuthorId, HostedFormUploadAuthorId, } from "./constants";
import { toPhoneNumberE164 } from "./telecom";
import { UserPreferences } from "./user-preferences";
export class User {
    constructor() {
        this.name = "";
        this.firstName = ""; // internal use only for bulk emails
        this.phone = toPhoneNumberE164("");
        this.tenantId = null;
        this.email = "";
        this.displayEmail = null;
        this.signedEula = null;
        this.id = null;
        this.preferences = new UserPreferences();
        this.useDirectEmail = false;
    }
    static sanitizeFromFull(doc) {
        const obj = {
            name: doc.name,
            firstName: doc.firstName,
            tenantId: doc.tenantId,
            email: doc.email,
            displayEmail: doc.displayEmail,
            tenant: doc.tenant,
            id: doc.id,
            signedEula: doc.signedEula,
            phone: toPhoneNumberE164(doc.phone),
            referralEmailSubj: doc.referralEmailSubj,
            referralEmailBody: doc.referralEmailBody,
            commInfoEmailSubj: doc.commInfoEmailSubj,
            commInfoEmailBody: doc.commInfoEmailBody,
            preferences: UserPreferences.load(doc.preferences),
            disabled: doc.disabled || false,
            hidden: doc.hidden || false,
            useDirectEmail: doc.useDirectEmail || false,
            twoFactorEmailEnabled: doc.twoFactorEmailEnabled || false,
            twoFactorSmsEnabled: doc.twoFactorSmsEnabled || false,
            type: doc.type || "user",
        };
        return obj;
    }
    static load(doc) {
        const result = new User();
        result.name = doc.name;
        result.firstName = doc.firstName;
        result.password = doc.password;
        result.tenantId = doc.tenantId;
        result.email = doc.email;
        result.displayEmail = doc.displayEmail;
        result.tenant = doc.tenant;
        result.signedEula = doc.signedEula;
        result.phone = toPhoneNumberE164(doc.phone);
        result.id = doc.id;
        result.referralEmailSubj = doc.referralEmailSubj;
        result.referralEmailBody = doc.referralEmailBody;
        result.commInfoEmailSubj = doc.commInfoEmailSubj;
        result.commInfoEmailBody = doc.commInfoEmailBody;
        result.preferences = UserPreferences.load(doc.preferences);
        result.disabled = doc.disabled || false;
        result.hidden = doc.hidden || false;
        result.useDirectEmail = doc.useDirectEmail || false;
        result.twoFactorEmailEnabled = doc.twoFactorEmailEnabled || false;
        result.twoFactorSmsEnabled = doc.twoFactorSmsEnabled || false;
        return result;
    }
}
export const isCrmAuthor = (id) => {
    if (!id) {
        return false;
    }
    return CrmAuthorId === id;
};
export function displayName(user) {
    if (!user) {
        return "unknown";
    }
    if (user.name && user.name !== "") {
        return user.name;
    }
    if (user.email && user.email !== "") {
        return user.email;
    }
    return "unknown";
}
export function displayNameById(userId, users) {
    if (userId === evergreenContactAuthorId) {
        return "Community";
    }
    if (userId === HostedFormUploadAuthorId) {
        return "hosted form file upload";
    }
    return displayName(users[userId]);
}
export function truncatedDisplayName(user, maxLength = 12) {
    const result = displayName(user);
    if (result.length > maxLength) {
        return `${result.substring(0, maxLength - 1)}…`;
    }
    return result;
}
//# sourceMappingURL=user.js.map